import {
  FETCH_DEPARTMENTS_REQUEST,
  FETCH_DEPARTMENTS_SUCCESS,
  FETCH_DEPARTMENTS_FAILURE,
  CREATE_DEPARTMENT,
  UPDATE_DEPARTMENT,
  DELETE_DEPARTMENT,
  CREATE_DEPARTMENT_REQUEST,
  CREATE_DEPARTMENT_SUCCESS,
  CREATE_DEPARTMENT_FAILURE,
  UPDATE_DEPARTMENT_REQUEST,
  UPDATE_DEPARTMENT_SUCCESS,
  UPDATE_DEPARTMENT_FAILURE,
  DELETE_DEPARTMENT_REQUEST,
  DELETE_DEPARTMENT_SUCCESS,
  DELETE_DEPARTMENT_FAILURE
} from '../../types/department/departmentTypes';

const initialState = {
  departments: [],
  loading: false,
  error: null,
  createLoading: false,
  updateLoading: false,
  deleteLoading: false
};

const departmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DEPARTMENTS_REQUEST:
      return { ...state, loading: true };

    case FETCH_DEPARTMENTS_SUCCESS:
      return { ...state, loading: false, departments: action.payload };

    case FETCH_DEPARTMENTS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Create loading states
    case CREATE_DEPARTMENT_REQUEST:
      return { ...state, createLoading: true };

    case CREATE_DEPARTMENT_SUCCESS:
      return {
        ...state,
        createLoading: false,
        departments: [...state.departments, action.payload]
      };

    case CREATE_DEPARTMENT_FAILURE:
      return { ...state, createLoading: false, error: action.payload };

    // Update loading states
    case UPDATE_DEPARTMENT_REQUEST:
      return { ...state, updateLoading: true };

    case UPDATE_DEPARTMENT_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        departments: state.departments.map((d) =>
          d.id === action.payload.id ? { ...d, ...action.payload.data } : d
        )
      };

    case UPDATE_DEPARTMENT_FAILURE:
      return { ...state, updateLoading: false, error: action.payload };

    // Delete loading states
    case DELETE_DEPARTMENT_REQUEST:
      return { ...state, deleteLoading: true };

    case DELETE_DEPARTMENT_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
        departments: state.departments.filter((d) => d.id !== action.payload)
      };

    case DELETE_DEPARTMENT_FAILURE:
      return { ...state, deleteLoading: false, error: action.payload };

    // Legacy cases for backward compatibility
    case CREATE_DEPARTMENT:
      return {
        ...state,
        departments: [...state.departments, action.payload],
      };

    case DELETE_DEPARTMENT:
      return {
        ...state,
        departments: state.departments.filter((d) => d.id !== action.payload),
      };

    case UPDATE_DEPARTMENT:
      return {
        ...state,
        departments: state.departments.map((d) =>
          d.id === action.payload.id ? { ...d, ...action.payload.data } : d
        ),
      };

    default:
      return state;
  }
};

export default departmentReducer;
